import { Navigate } from "react-router-dom";
import routes from "../../../routes/routes";

export default function DesignRedirect({ children }) {
  const allowed = ["development", "staging"];
  if (!allowed.includes(import.meta.env.VITE_ENV))
    return <Navigate to={routes.Home} />;
  return children;
}
